import { render, staticRenderFns } from "./PdvClosedReverse.vue?vue&type=template&id=3e6f8639"
import script from "./PdvClosedReverse.vue?vue&type=script&lang=js"
export * from "./PdvClosedReverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports